import React, { useState } from 'react'

import { Button } from '@zendeskgarden/react-buttons'
import { Field, Label, Input, Message } from '@zendeskgarden/react-forms'
import { Col, Row } from '@zendeskgarden/react-grid'
import { Header, Body } from '@zendeskgarden/react-modals'
import styled from 'styled-components'
import { useStateWithLocalStorage } from './localStorage'
import { postData } from '../../utils/http'

const BodyText = styled.div`
  margin-bottom: 10px;
`

const ManageSubscriptionRequest = ({ onClose, setSuccessFlash, setErrorFlash }) => {
  const [email, setEmail] = useStateWithLocalStorage('myEmail')
  const [once, setOnce] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  const renderEnmailInput = () => {
    if (!once || validateEmail(email)) {
      return (
        <div>
          <Input
            value={email}
            onChange={event => setEmail(event.target.value.trim())}
            onBlur={() => setOnce(true)}
            validation="success"
          />
        </div>
      )
    }
    return (
      <div>
        <Input
          value={email}
          onChange={event => setEmail(event.target.value.trim())}
          onBlur={() => setOnce(true)}
          validation="error"
        />
        <Message validation="error">Email format is invalid</Message>
      </div>
    )
  }

  async function submit() {
    setIsLoading(true)
    postData('/api/ssp/subscription_tokens?flow=manage', { email })
      .then(data => {
        if (data && data.message) {
          setSuccessFlash(data.message)
        } else if (data && data.errors) {
          setErrorFlash(data.errors.join(", "))
        }
        onClose()
      })
      .catch(error => {
        console.error('Error:', error)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  function cancel() {
    onClose()
  }

  return (
    <div>
      <Header>
        Manage status notification subscriptions
      </Header>
      <Body>
        <Row>
          <Col textAlign="left">
            <BodyText>
              Start by entering your email address to manage your
              status notification subscriptions.
            </BodyText>
          </Col>
        </Row>
        <Row>
          <Col textAlign="left">
            <BodyText>
              <Field>
                <Label>Email</Label>
                {renderEnmailInput()}
              </Field>
            </BodyText>
          </Col>
        </Row>
        <Row>
          <Col sm="4" />
          <Col xs="3">
            <Button isBasic
              onClick={() => {cancel()}}>
              Cancel
            </Button>
          </Col>
          <Col sm="5">
            <Button isPrimary
              onClick={() => {submit()}}
              disabled={!validateEmail(email) || isLoading}
              isLoading={isLoading}>
              Request link to manage
            </Button>
          </Col>
        </Row>
      </Body>
    </div>
  )
}

export default ManageSubscriptionRequest
